<template>
  <b-modal
    id="rename-modal"
    cancel-title="Annulla"
    cancel-variant="outline-secondary"
    centered
    ok-title="Rinomina"
    title="Rinomina"
    @ok="update"
  >
    <b-form>
      <b-form-group>
        <label for="name">Nome:</label>
        <b-form-input
          id="name"
          v-model="label"
          placeholder="Nome Cartella"
          type="text"
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import objectsRepository from '@/api/objectsRepository'
import useMyStore from '@/services/useMyStore'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'Modal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
  },
  props: {
    files: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup() {
    const { currentObject } = useMyStore()
    return { currentObject }
  },
  data() {
    return {
      status: false,
      label: '',
    }
  },
  computed: {

  },
  watch: {
    currentObject(val) {
      const file = this.files.find(el => el.id === val)
      if (file) this.label = file.label
    },
  },
  methods: {
    async update() {
      this.$emit('loading', true)
      const { data } = await objectsRepository.update(this.currentObject, {
        label: this.label,
      })
      if (data.code) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Successo!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.$emit('renamed')
      } else {
        console.log('error update folder')
      }
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style>
[dir="ltr"] .modal-header .close {
  margin: -0.5rem -0.6rem -0.5rem auto;
}
</style>
